import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

export interface CrmCatalogueTag {
  id: string;
  name: string;
  slug: string;
  scopeType: "global" | "organisation";
  organisationId: string | null;
  archivedAt: string | null;
  usageCount: number;
  lastUsedAt: string | null;
  isSystemManaged: boolean;
  canManage: boolean;
}
export type CrmCatalogueOperation = "rename" | "archive" | "restore" | "delete";
export interface CrmTagCatalogueResponse {
  items: CrmCatalogueTag[];
  canCreate: boolean;
  usageIsPartial: boolean;
  pagination: {
    total: number;
    offset: number;
    limit: number;
    hasMore: boolean;
  };
}
const invalidation = [
  "AdminV2GrowthTags",
  "AdminV2CrmActionScopes",
  "AdminV2CrmPeople",
  "AdminV2CrmUsers",
  "AdminV2CrmOrganisations",
  "AdminV2CrmFirms",
  "AdminV2AuditLog",
  "AdminV2LiveAlerts",
] as const;
export const buildAdminV2CrmTagCatalogueEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2CrmTagMatchingRecords: builder.query<
    {
      items: Array<{
        id: string;
        name: string;
        entityType: "contact" | "user" | "organisation" | "partner";
      }>;
      pagination: CrmTagCatalogueResponse["pagination"];
    },
    {
      tagId: string;
      entityType: "contact" | "user" | "organisation" | "partner";
      offset: number;
    }
  >({
    query: ({ tagId, ...params }) => ({
      url: `/admin/v2/crm/tags/${encodeURIComponent(tagId)}/records`,
      params,
    }),
    providesTags: ["AdminV2GrowthTags"],
  }),
  getAdminV2CrmTagCatalogue: builder.query<
    CrmTagCatalogueResponse,
    { q?: string; status?: "all" | "active" | "archived"; offset?: number }
  >({
    query: (params) => ({ url: "/admin/v2/crm/tags", params }),
    providesTags: ["AdminV2GrowthTags"],
  }),
  createAdminV2CrmCatalogueTag: builder.mutation<
    {
      tag: Pick<CrmCatalogueTag, "id" | "name" | "archivedAt">;
      created: boolean;
    },
    { name: string }
  >({
    query: (data) => ({ url: "/admin/v2/crm/tags", method: "POST", data }),
    invalidatesTags: (result) => (result ? [...invalidation] : []),
  }),
  changeAdminV2CrmCatalogueTag: builder.mutation<
    { tagId: string; operation: CrmCatalogueOperation; changed: boolean },
    { tagId: string; operation: CrmCatalogueOperation; name?: string }
  >({
    query: ({ tagId, ...data }) => ({
      url: `/admin/v2/crm/tags/${encodeURIComponent(tagId)}/change`,
      method: "POST",
      data,
    }),
    invalidatesTags: (result) => (result ? [...invalidation] : []),
  }),
});
